import React, { useState } from "react";
import Header from "../../../layouts/Header";
import Sidebar from "../../../layouts/Sidebar";

const AddUser = () => {
  const [menu, setMenu] = useState(false);
  const [IsChartered, setIsChartered] = useState(false);
  const [IsMarried, setIsMarried] = useState(false);
  const [IsChild, setIsChild] = useState(false);
  const [rowChild, setRowChild] = useState([
    {
      relative_prefix: "",
      relative_name: "",
      relation: "",
      do_birth: "",
    },
  ]);

  const [formData, setFormData] = useState({
    GroupMasterHeader: "",
    GroupMasterDetail: "",
    UserRole: "",
    UserPrifixName: "",
    UserFirstName: "",
    UserMiddleName: "",
    UserLastName: "",
    UserSuffixName: "",
    UserBloodGroup: "",
    UserGender: "",
    UserHomeAddress1: "",
    UserHomeAddress2: "",
    UserHomeAddress3: "",
    UserCountry: "",
    UserState: "",
    UserCity: "",
    UserPinCode: "",
    UserContactNo: "",
    UserEmail: "",
    UserPassword: "",
    UserDateOfBirth: "",
    UserDateOfJoining: "",
    UserCharteredAssociateNo: "",
    UserSpouseName: "",
    UserAniversaryDate: "",
  });

  const [validation, setValidation] = useState({
    GroupMasterHeader: { isValid: true, message: "" },
    GroupMasterDetail: { isValid: true, message: "" },
    UserRole: { isValid: true, message: "" },
    UserPrifixName: { isValid: true, message: "" },
    UserFirstName: { isValid: true, message: "" },
    UserMiddleName: { isValid: true, message: "" },
    UserLastName: { isValid: true, message: "" },
    UserGender: { isValid: true, message: "" },
    UserHomeAddress1: { isValid: true, message: "" },
    UserCountry: { isValid: true, message: "" },
    UserState: { isValid: true, message: "" },
    UserCity: { isValid: true, message: "" },
    UserContactNo: { isValid: true, message: "" },
    UserEmail: { isValid: true, message: "" },
    UserPassword: { isValid: true, message: "" },
    UserPinCode: { isValid: true, message: "" },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleIsChartered = () => {
    setIsChartered(!IsChartered);
  };

  const handleIsMarried = () => {
    setIsMarried(!IsMarried);
  };

  const handleIsChild = () => {
    setIsChild(!IsChild);
  };

  const handleAddRow = (e) => {
    e.preventDefault();
    setRowChild([
      ...rowChild,
      {
        relative_prefix: "",
        relative_name: "",
        relation: "",
        do_birth: "",
      },
    ]);
    console.log(rowChild);
  };

  const handleChangeDynamic = (idx) => (e) => {
    console.log(rowChild);
    const { name, value } = e.target;
    const copyRowChild = [...rowChild];
    var item = rowChild[idx];
    item[name] = value;
    copyRowChild[idx] = item;
    setRowChild(copyRowChild);
  };

  const removeSpecificRow = (idx) => (e) => {
    e.preventDefault();
    console.log(rowChild);
    const copyRowChild = [...rowChild];
    copyRowChild.splice(idx, 1);
    setRowChild(copyRowChild);
  };

  const handleInputChange = (fieldName, value) => {
    let isValid = true;
    let message = "";

    const nameRegex = /^[a-zA-Z\s]*$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (value === "") {
      isValid = false;
      message = "Field cannot be empty";
    }
    if (fieldName === "UserHomeAddress1") {
      console.log("UserHomeAddress1: ", value);
    }

    setFormData({
      ...formData,
      [fieldName]: value,
    });

    setValidation({
      ...validation,
      [fieldName]: { isValid, message },
    });

    console.log(formData);
    console.log(validation);
  };

  const handleSubmitted = (e) => {
    e.preventDefault();
    let isFormValid = true;
    Object.keys(formData).forEach((fieldName) => {
      if (formData[fieldName] === "") {
        console.log("handleSubmitted", fieldName);
        isFormValid = false;
        setValidation((prevValidation) => ({
          ...prevValidation,
          [fieldName]: { isValid: false, message: "Field cannot be empty" },
        }));
      }
    });
    let isBillingValid = true;
    console.log(validation);
    if (!isFormValid || !isBillingValid) {
      return;
    }

    console.log(formData);
    console.log(validation);
  };

  const checkIsChartered = () => {
    if (IsChartered) {
      
      return true
    }
    return false;
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={(value) => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="p-8">
            <div className="pb-6">
              <h1 className="text-2xl text-black">Create User</h1>
              <span className="text-red-500">Admin & User Side</span>
            </div>
            <form className="w-full">
              <div className="flex flex-wrap -mx-3">
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="GroupHeader"
                  >
                    Group Header <span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.GroupMasterHeader.isValid
                          ? "border-red-400"
                          : ""
                      }`}
                      value={formData.GroupMasterHeader}
                      onChange={(e) => {
                        handleInputChange("GroupMasterHeader", e.target.value);
                      }}
                    >
                      <option size="large" value={null}>
                        Please Select
                      </option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="GroupDetail"
                  >
                    Group Detail <span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500  ${
                        !validation.GroupMasterDetail.isValid
                          ? "border-red-400"
                          : ""
                      }`}
                      value={formData.GroupMasterDetail}
                      onChange={(e) => {
                        handleInputChange("GroupMasterDetail", e.target.value);
                      }}
                    >
                      <option size="large" value={null}>
                        Please Select
                      </option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="DateOfJoining"
                  >
                    Date Of Joining <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500`}
                    id="grid-last-name"
                    type="date"
                    placeholder="Date Of Joining"
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 py-1 mb-6">
                  <div className="relative">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="IsChartered"
                      onClick={handleIsChartered}
                    >
                      <input
                        type="checkbox"
                        checked={IsChartered}
                        onChange={(e) => setIsChartered(!IsChartered)}
                      />
                      <span className="pl-1"> Is Chartered</span>
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="IsChartered"
                      type="text"
                      placeholder="Chartered Associate No"
                      disabled={!IsChartered}
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="UserRole"
                  >
                    User Role <span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.UserRole.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.UserRole}
                      onChange={(e) => {
                        handleInputChange("UserRole", e.target.value);
                      }}
                    >
                      <option size="large" value={null}>
                        Please Select
                      </option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="UserPrifix"
                  >
                    User Prifix <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.UserPrifixName.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="User Prifix"
                    value={formData.UserPrifixName}
                    onChange={(e) => {
                      handleInputChange("UserPrifixName", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="FirstName"
                  >
                    First Name <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.UserFirstName.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="First Name"
                    value={formData.UserFirstName}
                    onChange={(e) => {
                      handleInputChange("UserFirstName", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="MiddleName"
                  >
                    Middle Name <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.UserMiddleName.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="Middle Name"
                    value={formData.UserMiddleName}
                    onChange={(e) => {
                      handleInputChange("UserMiddleName", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="LastName"
                  >
                    Last Name <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.UserLastName.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="Last Name"
                    value={formData.UserLastName}
                    onChange={(e) => {
                      handleInputChange("UserLastName", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="UserSuffix"
                  >
                    User Suffix
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500`}
                    type="text"
                    placeholder="User Suffix"
                    value={formData.UserSuffixName}
                    onChange={(e) => {
                      handleInputChange("UserSuffixName", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Gender"
                  >
                    Blood Group
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500`}
                      value={formData.UserBloodGroup}
                      onChange={(e) => {
                        handleInputChange("UserBloodGroup", e.target.value);
                      }}
                    >
                      <option size="large" value={null}>
                        Please Select
                      </option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="ContactNo"
                  >
                    Contact No <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.UserContactNo.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="Contact No"
                    value={formData.UserContactNo}
                    onChange={(e) => {
                      handleInputChange("UserContactNo", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Email"
                  >
                    Email Id <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.UserEmail.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="Email"
                    value={formData.UserEmail}
                    onChange={(e) => {
                      handleInputChange("UserEmail", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Password"
                  >
                    Password <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.UserPassword.isValid ? "border-red-400" : ""
                    }`}
                    type="password"
                    placeholder="Password"
                    value={formData.UserPassword}
                    onChange={(e) => {
                      handleInputChange("UserPassword", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Gender"
                  >
                    Gender <span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.UserGender.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.UserGender}
                      onChange={(e) => {
                        handleInputChange("UserGender", e.target.value);
                      }}
                    >
                      <option size="large" value={null}>
                        Please Select
                      </option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1"
                    htmlFor="IsMarried"
                    onClick={handleIsMarried}
                  >
                    <input
                      type="checkbox"
                      checked={IsMarried}
                      onChange={(e) => setIsMarried(!IsMarried)}
                    />
                    <span className="pl-1"> Is Married</span>
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-last-name"
                    type="text"
                    placeholder="Spouse Name"
                    disabled={!IsMarried}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="AniversaryDate"
                  >
                    Spouse Birth Date
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-1 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    type="date"
                    placeholder="Spouse Birth Date"
                    disabled={!IsMarried}
                    value={formData.UserAniversaryDate}
                    onChange={(e) => {
                      handleInputChange("UserAniversaryDate", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="AniversaryDate"
                  >
                    Aniversary Date
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-1 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    type="date"
                    placeholder="Aniversary Date"
                    disabled={!IsMarried}
                    value={formData.UserAniversaryDate}
                    onChange={(e) => {
                      handleInputChange("UserAniversaryDate", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/3 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="HomeAddress"
                  >
                    Home Address <span className="text-red-400"> *</span>
                  </label>
                  <textarea
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.UserHomeAddress1.isValid
                        ? "border-red-400"
                        : ""
                    }`}
                    name="body"
                    placeholder="Home Address"
                    value={formData.UserHomeAddress1}
                    onChange={(e) => {
                      handleInputChange("UserHomeAddress1", e.target.value);
                    }}
                  />
                  {/* <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-password"
                    type="password"
                    placeholder="******************"
                  />
                  <p className="text-gray-600 text-xs italic">
                    Make it as long and as crazy as you'd like
                  </p> */}
                </div>
                <div className="w-full md:w-1/3 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="HomeAddress2"
                  >
                    Home Address 2
                  </label>
                  <textarea
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    name="body"
                    placeholder="Home Address 2"
                    value={formData.UserHomeAddress2}
                    onChange={(e) => {
                      handleInputChange("UserHomeAddress2", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="HomeAddress3"
                  >
                    Home Address 3
                  </label>
                  <textarea
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    name="body"
                    placeholder="Home Address 3"
                    value={formData.UserHomeAddress3}
                    onChange={(e) => {
                      handleInputChange("UserHomeAddress3", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Country"
                  >
                    Country <span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.UserCountry.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.UserCountry}
                      onChange={(e) => {
                        handleInputChange("UserCountry", e.target.value);
                      }}
                    >
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="State"
                  >
                    State <span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.UserState.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.UserState}
                      onChange={(e) => {
                        handleInputChange("UserState", e.target.value);
                      }}
                    >
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="City"
                  >
                    City <span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.UserCity.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.UserCity}
                      onChange={(e) => {
                        handleInputChange("UserCity", e.target.value);
                      }}
                    >
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="ZipCode"
                  >
                    Zip Code <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.UserPinCode.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="Zip Code"
                    value={formData.UserPinCode}
                    onChange={(e) => {
                      handleInputChange("UserPinCode", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3 mb-2">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="IsChild"
                    onClick={handleIsChild}
                  >
                    <input
                      type="checkbox"
                      checked={IsChild}
                      onChange={(e) => setIsChild(e.target.checked)}
                    />
                    {/* e => setIsChild(e.target.checked) */}
                    <span className="pl-1"> Is Child</span>
                  </label>
                </div>
                <div className="w-full px-3 mb-6">
                  {IsChild == true ? (
                    <div className="overflow-y-hidden pb-4">
                      <table
                        className="table table-bordered table-hover w-full"
                        id="tab_logic"
                      >
                        <thead>
                          <tr className="bg-white">
                            <th className="text-center border border-gray-200">
                              #
                            </th>
                            <th className="text-center border border-gray-200 min-w-24">
                              Prefix
                            </th>
                            <th className="text-center border border-gray-200 min-w-24">
                              Name
                            </th>
                            <th className="text-center border border-gray-200 min-w-24">
                              Relation
                            </th>
                            <th className="text-center border border-gray-200 min-w-24">
                              Date Of Birth
                            </th>
                            <th className="text-center border border-gray-200">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {rowChild.map((item, idx) => (
                            <tr id="addr0" key={idx}>
                              <td>{idx}</td>
                              <td className="p-1">
                                <input
                                  name="relative_prefix"
                                  value={rowChild[idx].relative_prefix}
                                  onChange={handleChangeDynamic(idx)}
                                  className="w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-4"
                                  placeholder="Prefix"
                                />
                              </td>
                              <td className="p-1">
                                <input
                                  name="relative_name"
                                  value={rowChild[idx].relative_name}
                                  onChange={handleChangeDynamic(idx)}
                                  className="w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-4"
                                  placeholder="Name"
                                />
                              </td>
                              <td className="p-1">
                                <input
                                  name="relation"
                                  value={rowChild[idx].relation}
                                  onChange={handleChangeDynamic(idx)}
                                  className="w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-4"
                                  placeholder="Relation"
                                />
                              </td>
                              <td className="p-1">
                                <input
                                  name="do_birth"
                                  value={rowChild[idx].do_birth}
                                  onChange={handleChangeDynamic(idx)}
                                  className="w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-1 px-4"
                                  placeholder="Date Of Birth"
                                  type="date"
                                />
                              </td>
                              <td className="text-center">
                                {idx == 0 ? null : (
                                  <button
                                    className="text-red-600"
                                    type="primary"
                                    onClick={removeSpecificRow(idx)}
                                  >
                                    <svg
                                      className="fill-current w-7 h-7 mr-2"
                                      enableBackground="new 0 0 32 32"
                                      id="Glyph"
                                      version="1.1"
                                      viewBox="0 0 32 32"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M27,6h-6V5c0-1.654-1.346-3-3-3h-4c-1.654,0-3,1.346-3,3v1H5C3.897,6,3,6.897,3,8v1c0,0.552,0.448,1,1,1h24  c0.552,0,1-0.448,1-1V8C29,6.897,28.103,6,27,6z M13,5c0-0.551,0.449-1,1-1h4c0.551,0,1,0.449,1,1v1h-6V5z"
                                        id="XMLID_246_"
                                      />
                                      <path
                                        d="M6,12v15c0,1.654,1.346,3,3,3h14c1.654,0,3-1.346,3-3V12H6z M19.707,22.293  c0.391,0.391,0.391,1.023,0,1.414s-1.023,0.391-1.414,0L16,21.414l-2.293,2.293c-0.391,0.391-1.023,0.391-1.414,0  s-0.391-1.023,0-1.414L14.586,20l-2.293-2.293c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0L16,18.586l2.293-2.293  c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414L17.414,20L19.707,22.293z"
                                        id="XMLID_249_"
                                      />
                                    </svg>
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <button
                        className="border-solid border-2 hover:border-green-700 border-gray-200 py-1 px-2 rounded ml-4 md:ml-6"
                        type="primary"
                        onClick={handleAddRow}
                      >
                        <svg
                          height="24px"
                          id="Layer_1"
                          version="1.1"
                          viewBox="0 0 512 512"
                          width="24px"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g>
                            <polygon points="429,328 429,277 480,277 480,235 429,235 429,184 387,184 387,235 336,235 336,277 387,277 387,328  " />
                            <path d="M416,448c0,0,0-26.4-2.2-40.2c-1.8-10.9-16.9-25.3-81.1-48.9c-63.2-23.2-59.3-11.9-59.3-54.6c0-27.7,14.1-11.6,23.1-64.2   c3.5-20.7,6.3-6.9,13.9-40.1c4-17.4-2.7-18.7-1.9-27c0.8-8.3,1.6-15.7,3.1-32.7C313.4,119.3,293.9,64,224,64   c-69.9,0-89.4,55.3-87.5,76.4c1.5,16.9,2.3,24.4,3.1,32.7c0.8,8.3-5.9,9.6-1.9,27c7.6,33.1,10.4,19.3,13.9,40.1   c9,52.6,23.1,36.5,23.1,64.2c0,42.8,3.9,31.5-59.3,54.6c-64.2,23.5-79.4,38-81.1,48.9C32,421.6,32,448,32,448h192H416z" />
                          </g>
                        </svg>
                        {/* Add Row */}
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-6">
                  <button
                    onClick={handleSubmitted}
                    className="bg-gray-100 hover:bg-green-300 text-green-700 font-bold border-solid border-2 hover:border-green-400 border-gray-200 py-2 px-4 rounded inline-flex items-center float-right"
                  >
                    <svg
                      className="fill-current"
                      height="20"
                      viewBox="0 0 512 512"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M465.94,119.76l-73.7-73.7h0A47.68,47.68,0,0,0,358.3,32H96A64,64,0,0,0,32,96V416a64,64,0,0,0,64,64H416a64,64,0,0,0,64-64V153.7A47.68,47.68,0,0,0,465.94,119.76ZM120,112H296a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H120a8,8,0,0,1-8-8V120A8,8,0,0,1,120,112ZM259.75,431.91a80,80,0,1,1,76.16-76.16A80.06,80.06,0,0,1,259.75,431.91Z" />
                      <circle cx="256" cy="352" r="48" />
                    </svg>
                    <span className="pl-2">Create User</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddUser;
